import { createElement, memo, useMemo, } from 'react';
import useMediaQueryState from './useMediaQueryState';
const MediaQueryState = ({ children, localWindow, mediaQuerySize, }) => {
    const mediaQueryState = (useMediaQueryState({
        localWindow,
        mediaQuerySize,
    }));
    const childProps = (useMemo(() => ({
        mediaQueryState,
    }), [
        mediaQueryState,
    ]));
    return (createElement(children, childProps));
};
const MemoizedMediaQueryState = memo(MediaQueryState);
MediaQueryState.mediaQueryStates = useMediaQueryState.mediaQueryStates;
export default MemoizedMediaQueryState;
